import { Component, Fragment } from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

import { translate } from '../../../i18n';
import styles from './PaymentSection.style';

interface Props {
  name: string;
  valueLayoutStyles: StyleProp<ViewStyle>;
  valueTemplate: (v, p) => JSX.Element;
  theValue: string;
  hintTemplate: JSX.Element;
  separatorTemplate: JSX.Element;
  shouldRefresh: boolean;
  fetchTransactionDetail: Function;
  transactionID: number;
}

interface State {
  refreshSec: number;
}

export default class PaymentItem extends Component<Props, State> {
  refreshInterval?: NodeJS.Timer;
  _isUnmount = false;

  constructor(props) {
    super(props);

    this.state = {
      refreshSec: 10,
    };
  }

  clearRefreshInterval = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  };

  fetchTransactionDetail = () => {
    if (
      this.state.refreshSec > 0 &&
      this.props.shouldRefresh &&
      !this._isUnmount
    ) {
      this.props.fetchTransactionDetail({
        transactionID: this.props.transactionID,
        silent: true,
        onSuccess: this.fetchTransactionDetail,
      });
    }
  };

  counterTimer = () => {
    if (this.state.refreshSec > 0) {
      const refreshSec = this.state.refreshSec - 1;

      this.setState({ refreshSec });
    } else {
      this.clearRefreshInterval();
    }
  };

  setRefreshInterval = () => {
    this.clearRefreshInterval();
    this.refreshInterval = setInterval(this.counterTimer, 1000);
    this.fetchTransactionDetail();
  };

  componentDidMount() {
    if (this.props.shouldRefresh) {
      this.setRefreshInterval();
    }
  }

  componentWillUnmount() {
    this.clearRefreshInterval();
    this._isUnmount = true;
  }

  render() {
    const {
      name,
      valueLayoutStyles,
      hintTemplate,
      valueTemplate,
      separatorTemplate,
      theValue,
    } = this.props;

    const { refreshSec } = this.state;

    const isAccountName = name === 'account_number';

    return (
      <Fragment>
        <View
          style={[
            styles.dataField,
            isAccountName ? styles.flexCol : styles.flexRow,
          ]}
          key={`payment-data-${name}`}
        >
          <Text style={styles.dataKeyText}>
            {translate(`orderDetail-${name.replace(/_/g, '-')}`)}：
          </Text>
          <View style={valueLayoutStyles}>
            {valueTemplate(theValue, { sec: refreshSec })}
            {hintTemplate}
          </View>
        </View>
        {separatorTemplate}
      </Fragment>
    );
  }
}
